import './Footer.css';
import { contactInfo } from '../../../data/content';

function Footer() {
  return (
    <footer className="site-footer">
      <div className="ft-topbar"></div>

      {/* ══ MAIN GRID ══ */}
      <div className="ft-inner">

        {/* Col 1 — Brand */}
        <div className="ft-brand">
          <div className="ft-brand-top">
            {/* <div className="ft-icon">🌽</div> */}
            <div>
              <div className="ft-bname">Corn Bliss</div>
              <div className="ft-btag">Trusted · Reliable · Always Here</div>
            </div>
          </div>
          <p className="ft-desc">
            Fresh from the farm to your table. We deliver quality produce
            with care, every single day.
          </p>
          <div className="ft-sbadge">
            <span className="sdot"></span>
            {contactInfo.status}
          </div>
        </div>

        {/* Col 2 — Contact */}
        <div className="ft-col">
          <h3>Get in Touch</h3>

          {contactInfo.phones.map((phone, i) => (
            <div className="ft-row" key={i}>
              <div className="ft-ci">📞</div>
              <div>
                <div className="ft-clabel">Phone {contactInfo.phones.length > 1 ? i + 1 : ''}</div>
                <div className="ft-cval">{phone}</div>
              </div>
            </div>
          ))}

          <div className="ft-row">
            <div className="ft-ci">💬</div>
            <div>
              <div className="ft-clabel">WhatsApp</div>
              <div className="ft-cval">
                <a href={`https://wa.me/${contactInfo.whatsapp.replace(/\s+/g, '')}`} target="_blank" rel="noopener noreferrer">
                  {contactInfo.whatsapp}
                </a>
              </div>
            </div>
          </div>

          <div className="ft-row">
            <div className="ft-ci">✉️</div>
            <div>
              <div className="ft-clabel">Email</div>
              <div className="ft-cval">
                <a href={`mailto:${contactInfo.email}`}>{contactInfo.email}</a>
              </div>
            </div>
          </div>
        </div>

        {/* Col 3 — Quick Links */}
        <div className="ft-col">
          <h3>Quick Links</h3>
          <ul className="ft-links">
            <li><a href="/">Home</a></li>
            <li><a href="/about">About Us</a></li>
            <li><a href="/more">Products</a></li>
            <li><a href="/contact">Contact</a></li>
          </ul>
        </div>

        {/* Col 4 — Follow Us */}
        <div className="ft-col">
          <h3>Follow Us</h3>
          <div className="social-grid">
            <a
              className="spill spill-fb"
              href={contactInfo.social.facebook}
              target="_blank"
              rel="noopener noreferrer"
              title="Follow us on Facebook"
            >
              <div className="spill-icon">
                <svg viewBox="0 0 24 24" width="16" height="16" fill="white">
                  <path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z"/>
                </svg>
              </div>
              <span>Facebook</span>
            </a>
            <a
              className="spill spill-tk"
              href={`https://${contactInfo.social.tiktok}`}
              target="_blank"
              rel="noopener noreferrer"
              title="Follow us on TikTok"
            >
              <div className="spill-icon">
                <svg viewBox="0 0 24 24" width="16" height="16" fill="white">
                  <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-2.88 2.5 2.89 2.89 0 0 1-2.89-2.89 2.89 2.89 0 0 1 2.89-2.89c.28 0 .54.04.79.1V9.01a6.33 6.33 0 0 0-.79-.05 6.34 6.34 0 0 0-6.34 6.34 6.34 6.34 0 0 0 6.34 6.34 6.34 6.34 0 0 0 6.33-6.34V8.69a8.18 8.18 0 0 0 4.78 1.52V6.75a4.85 4.85 0 0 1-1.01-.06z"/>
                </svg>
              </div>
              <span>TikTok</span>
            </a>
            <a
              className="spill spill-ig"
              href={contactInfo.social.instagram}
              target="_blank"
              rel="noopener noreferrer"
              title="Follow us on Instagram"
            >
              <div className="spill-icon">
                <svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <rect x="2" y="2" width="20" height="20" rx="5" ry="5"/>
                  <circle cx="12" cy="12" r="4"/>
                  <circle cx="17.5" cy="6.5" r="1" fill="white" stroke="none"/>
                </svg>
              </div>
              <span>Instagram</span>
            </a>
          </div>
        </div>

      </div>

      {/* ══ BOTTOM BAR ══ */}
      <div className="ft-bottom-wrap">
        <div className="ft-bot">
          <div className="ft-bot-left">
            <p>© {new Date().getFullYear()} Corn Bliss. All rights reserved.</p>
          </div>
          <div className="ft-bot-center">
            <div className="ft-accent"></div>
            <span className="ft-made">Made with 💚</span>
            <div className="ft-accent"></div>
          </div>
          <div className="ft-bot-right">
            <a href="/privacy">Privacy Policy</a>
            <a href="/terms">Terms</a>
          </div>
        </div>
      </div>

    </footer>
  );
}

export default Footer;